import PropTypes from "prop-types";
import CardSlider from "@components/CardSlider/CardSlider";

const BookSlider = (props) => {
  const { displayName = "BookSlider" } = props;

  return (
    <div className={displayName}>
      <div className="slider-header">{props.slider_heading}</div>
      <hr />
      <CardSlider
        cardType="bookCard"
        slidesToShow={1}
        slides={props.books}
        className="book-card-slider"
        autoplay={true}
        dots={true}
        autoplaySpeed={8000}
        pauseOnHover={true}
        lazyLoad={true}
      />
    </div>
  );
};

export default BookSlider;

BookSlider.propTypes = {
  displayName: PropTypes.string,
  slider_heading: PropTypes.string,
  books: PropTypes.array,
};
